export const getStaticAssetsUrl = (path: string = '') => {
  const assetsHost =
    window.__HB_ENV__.ENVIRONMENT === 'development' ||
    window.__HB_ENV__.ENVIRONMENT === 'test'
      ? 'https://static.hvbrt.com'
      : window.__HB_ENV__.STATIC_ASSETS_HOST;

  return `${assetsHost}${path}`;
};
